import React, { useEffect, useState } from "react";

import "./Videos.scss";
import Button from "../../components/atoms/Button/Button";
import Input from "../../components/atoms/Input/Input";

// Assets
// import Seacrg_ from "../../assets/icons/BUSCAR.png";
import AnimatedCard from "../../components/molecules/AnimatedCard/AnimatedCard";
import TextArea from "../../components/atoms/TextArea/TextArea";
import { validateData } from "../../utiles/ValidateEntries";
import ValidationMessage from "../../components/atoms/ValidationMessage/ValidationMessage";
import { resources } from "../../services/resources";
import { toast, Toaster } from "sonner";

const Videos = () => {
    const [openVideoForm, setOpenVideoForm] = useState(false);

    const [videoData, setVideoData] = useState({
        title: "",
        description: "",
        videoUrl: "",
    });

    const getEmbedUrl = (url) => {
        const videoId = url.split("v=")[1]?.split("&")[0];
        return `https://www.youtube.com/embed/${videoId}`;
    };

    const [emptyField, setEmptyField] = useState({});

    const eventChange = (e) => {
        const { name, value } = e.target;

        setVideoData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setEmptyField((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const handleUpVideo = async (e) => {
        e.preventDefault();

        try {
            const { status, emptyFields } = validateData(videoData);

            setEmptyField(emptyFields);

            if (!status) {
                console.error(
                    "Por favor, completa todos los campos requeridos."
                );
                return;
            }

            const toast_id = toast("Procesando...");
            const response = await resources.createVideo(videoData);

            if (!response.success) {
                toast.error("¡Ups!", {
                    description:
                        "El video con ese titulo ya existe, intenta con otro.",
                    position: "top-right",
                    duration: 5000,
                    icon: "⭕️",
                    id: toast_id,
                });

                return;
            }

            toast.success("Exito!", {
                description: response.message,
                position: "top-right",
                duration: 5000,
                icon: "✅",
                id: toast_id,
            });

            setVideoAll((prev) => [...prev, videoData]);

            setVideoData({
                title: "",
                description: "",
                videoUrl: "",
            });

            setOpenVideoForm(false);
        } catch (error) {
            console.error("Ocurrio un error", error);
        }
    };

    const [videoAll, setVideoAll] = useState([]);

    const getvideoAll = async () => {
        try {
            const response = await resources.getVideos();

            if (!response.success) {
                console.warn(
                    "La respuesta del servidor no contiene un recurso válido:"
                );
                return setVideoAll([]);
            }

            setVideoAll(response.data);
        } catch (error) {
            console.error("Error al obtener los videos:", error);
            return {
                success: false,
                message: "Error al obtener los videos",
                data: [],
            };
        }
    };

    useEffect(() => {
        getvideoAll();
    }, []);

    return (
        <>
            <div className="Videos_">
                <div className="v-header">
                    <h5 className="v-title">Videos</h5>
                    <div className="v-header_right">
                        <Input placeholder={"Buscar tutorial"} />
                    </div>
                </div>
                <div className="v-container">
                    <div
                        className="v-card v-up-video"
                        onClick={() => setOpenVideoForm(true)}
                    >
                        Agregar nuevo video
                        <span>+</span>
                    </div>
                    {videoAll.map((v, idx) => (
                        <div key={idx} className="v-card">
                            <iframe
                                className="v-iframe"
                                src={getEmbedUrl(v.videoUrl)}
                                title={v.title}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                                sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-presentation"
                            ></iframe>

                            <p className="v-description">{v.description}</p>
                        </div>
                    ))}
                </div>
            </div>

            {openVideoForm && (
                <AnimatedCard
                    setClose={setOpenVideoForm}
                    title="Subir Video"
                    size="md"
                    variant="elegant"
                    coloredHeader={true}
                >
                    <form onSubmit={handleUpVideo} className="v-form">
                        <ValidationMessage show={emptyField.title}>
                            <Input
                                id={"title"}
                                placeholder={"Titulo"}
                                name={"title"}
                                onChange={eventChange}
                                show={emptyField.title}
                            />
                        </ValidationMessage>
                        <ValidationMessage show={emptyField.description}>
                            <TextArea
                                id={"description"}
                                name={"description"}
                                placeholder={"Descripción"}
                                show={emptyField.description}
                                onChange={eventChange}
                            />
                        </ValidationMessage>
                        <ValidationMessage show={emptyField.videoUrl}>
                            <Input
                                placeholder={"URL"}
                                id={"videoUrl"}
                                name={"videoUrl"}
                                onChange={eventChange}
                                show={emptyField.videoUrl}
                            />
                        </ValidationMessage>
                        <Button
                            text={"Subir"}
                            type={"submit"}
                            className="v_video degrad"
                            onClick={handleUpVideo}
                        />
                    </form>
                </AnimatedCard>
            )}
            <Toaster />
        </>
    );
};

export default Videos;
